const $ = window.jQuery

$(() => {
  const $pageSelectors = $('.page-selector')

  $pageSelectors.on('change', function () {
    window.location.href = $(this).val()
  })
})
